import styled from "styled-components";

export const GroupHighlightSectionLoadingSkeletonContainer = styled.div`
  height: 750px;

  padding: 0 3.125rem;

  display: flex;
  flex-direction: column;
  gap: 130px;

  margin: 0 0 40px 0;

  @media (min-width: 600px) {
    margin: 0 0 40px 0;
  }

  .texts {
    max-width: 500px;

    display: flex;
    flex-direction: column;
    gap: 20px;

    > div {
      width: 100%;
    }

    @media (max-width: 768px) {
      width: 100%;
      margin: 0 auto;

      > div {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }
  }
`;
